// removed by extract-text-webpack-plugin
module.exports = {"survey_header_container":"_22Ta5U5lvaICLtaAXqSx3S","logo_container":"l5i8M1_o9vpQYvudr_5TO","survey_name":"_1L8hbwyrDMGKJib30poAe_","powered_by":"CT6NdmZsnQebAfgb0u4-v","powered_by_name":"EP0FqY6HunBm-1dMcG3o4","signature_container":"c3WLBw544ZuaKP-UetRaP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SurveyHeader/SurveyHeader.scss
// module id = 2327
// module chunks = 0